import { relativeLuminance } from './colorLuminance'

export type RGB = {
  r: number
  g: number
  b: number
}

// #00ccff --> {r: 0, g: 204, b: 255}
export const hexToRgb = (hex: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  if (!result) throw Error('bad hex: ' + hex)
  return { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) }
}

// Equation taken from W3: https://www.w3.org/TR/WCAG21/#dfn-contrast-ratio
const contrastRatio = (luminance1: number, luminance2: number) => {
  const lighterLuminance = luminance1 > luminance2 ? luminance1 : luminance2
  const darkerLuminance = luminance1 > luminance2 ? luminance2 : luminance1

  return (lighterLuminance + 0.05) / (darkerLuminance + 0.05)
}

// This function does not guarantee a perfect foreground contrast, only that it will pick
// which of the two given foregroundColors has a higher contrast with the given backgroundColor.
export const getContrastingForeground = ({
  backgroundColor,
  darkForegroundColor,
  lightForegroundColor,
}: {
  backgroundColor: string // Hex, ex: '#de007b'
  darkForegroundColor: string // Hex
  lightForegroundColor: string // Hex
}) => {
  const backgroundLuminance = relativeLuminance(hexToRgb(backgroundColor))
  const lightForegroundLuminance = relativeLuminance(hexToRgb(lightForegroundColor))
  const darkForegroundLuminance = relativeLuminance(hexToRgb(darkForegroundColor))

  const lightForegroundContrast = contrastRatio(backgroundLuminance, lightForegroundLuminance)
  const darkForegroundContrast = contrastRatio(backgroundLuminance, darkForegroundLuminance)

  return darkForegroundContrast > lightForegroundContrast ? darkForegroundColor : lightForegroundColor
}
